import siteConfig from "site-config";

const managementRoute = (suffix) => {
    const host = siteConfig.api;
    return `${host}/management/${suffix}`;
};

export const brandNamesQuery = () => {
    return {
        url: managementRoute("brands"),
        options: { method: "GET" },
        doNotMutateUrl: true,
    };
};

export const saveProfileQuery = (data: any) => {
    return {
        url: managementRoute("retailer"),
        options: { method: "POST" },
        body: data,
        doNotMutateUrl: true,
    };
};
